var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fab-wrapper" },
    [
      _c(
        "v-speed-dial",
        {
          staticClass: "inner-speed-dial",
          attrs: {
            bottom: _vm.bottom,
            right: _vm.right,
            direction: "top",
            transition: _vm.transition,
            fixed: ""
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function() {
                return [
                  _c("FabButtonIcon", {
                    attrs: {
                      fab: _vm.fab,
                      "fab-model": _vm.fab,
                      isOuter: false
                    }
                  })
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.fab,
            callback: function($$v) {
              _vm.fab = $$v
            },
            expression: "fab"
          }
        },
        [
          _vm._v(" "),
          _c(
            "v-overlay",
            { attrs: { opacity: "0.5" } },
            [
              !_vm.shareLink
                ? _c(
                    "v-speed-dial",
                    {
                      staticClass: "inner-speed-dial",
                      attrs: {
                        bottom: _vm.bottom,
                        right: _vm.right,
                        direction: "top",
                        transition: _vm.transition,
                        fixed: ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function() {
                              return [
                                _c("FabButtonIcon", {
                                  attrs: {
                                    fab: _vm.fab,
                                    "fab-model": _vm.fab,
                                    isOuter: true
                                  }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3450195082
                      ),
                      model: {
                        value: _vm.fab,
                        callback: function($$v) {
                          _vm.fab = $$v
                        },
                        expression: "fab"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "v-speed-dial__list" },
                        [
                          _c("FabOptionButton", {
                            attrs: {
                              title: "REQUEST",
                              image: "mdi-file-document-edit-outline"
                            },
                            on: { fabOptionClicked: _vm.requestClicked }
                          }),
                          _vm._v(" "),
                          _c("FabOptionButton", {
                            attrs: { title: "SHARE", image: "mdi-share" },
                            on: { fabOptionClicked: _vm.shareClicked }
                          }),
                          _vm._v(" "),
                          _c("FabOptionButton", {
                            attrs: {
                              title: "UPLOAD",
                              image: "mdi-cloud-upload-outline"
                            },
                            on: { fabOptionClicked: _vm.uploadClicked }
                          })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.shareLink
        ? _c("SharingLink", {
            attrs: {
              "user-email": _vm.userEmail,
              "user-name": _vm.userName,
              "user-id": _vm.userId
            },
            on: {
              shareOptionClicked: function($event) {
                _vm.shareLink = !_vm.shareLink
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }